import Adicionar from './Adicionar';
import Assinar from './Assinar';
import Default from './Default';
import Editar from './Editar';
import Historico from './Historico';
import Relatorios from './Relatorios';

const FechamentosDeFolhaDefault = Default;

export default FechamentosDeFolhaDefault;
export const FechamentosDeFolhaAdicionar = Adicionar;
export const FechamentosDeFolhaEditar = Editar;
export const FechamentosDeFolhaRelatorios = Relatorios;
export const FechamentosDeFolhaHistorico = Historico;
export const FechamentosDeFolhaAssinar = Assinar;
